import "core-js/fn/object/assign";
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/Main";
import { BrowserRouter } from "react-router-dom";
import user from "stores/User";
import onlineWorkshop from "stores/OnlineWorkshop";
import searchFieldEventEmitter from "stores/SearchFieldEventEmitter";
import alert from "stores/Alert";
import workshopDetails from "stores/WorkshopDetails";
import { Provider } from "mobx-react";
import preloader from "stores/Preloader";
import deleteModal from "stores/DeleteModal";
import purchased from "stores/Purchased";
import regularWorkshopCreate from "stores/RegularWorkshopCreate";
import pagination from "stores/Pagination";
import responce from "stores/Responce";
import providerStore from "stores/ProviderStore";
import filter from "stores/Filter";
import SponsorStore from "stores/SponsorStore";
import webinarCreate from 'stores/WebinarCreate';
import publicWebinarCreate from 'stores/PublicWebinarCreate';
import publicWorkshopCreate from 'stores/PublicWorkshopCreate';
import organizationWebinarCreate from 'stores/OrganizationWebinarCreate';
import organizationWorkshopCreate from 'stores/OrganizationWorkshopCreate';

import modal from "stores/Modal";
import myRegularWorkshops from "stores/MyRegularWorkshops";

import "styles/css/custom.scss";
import "styles/css/provider.scss";

const stores = {
  user,
  searchFieldEventEmitter,
  providerStore,
  onlineWorkshop,
  alert,
  workshopDetails,
  preloader,
  deleteModal,
  purchased,
  regularWorkshopCreate,
  pagination,
  responce,
  modal,
  myRegularWorkshops,
  filter,
  SponsorStore,
  webinarCreate,
  publicWebinarCreate,
  publicWorkshopCreate,
  organizationWebinarCreate,
  organizationWorkshopCreate,
};
ReactDOM.render(
  <BrowserRouter>
    <Provider {...stores}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById("app")
);



// WEBPACK FOOTER //
// ./src/index.js